var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_vm._l((_vm.sources),function(ref){
var format = ref[0];
var formatSrc = ref[1];
return _c('source',{key:(formatSrc + "_" + format),attrs:{"srcset":formatSrc,"type":("image/" + (_vm.getType(format) || format))}})}),_c('img',_vm._b({attrs:{"alt":_vm.alt,"src":_vm.srcAbs}},'img',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }